<template>
<div class="confirm_order">
  <div class="order_card" v-if="conference.data.length >0">
      <div class="div">
        <p class="o_o" >{{hy_name}}</p>
        <div class="order_list">
          <template v-for="(items,index) in conference.data">
            <template v-for="(items2,index2) in items.member">
          <van-row class="order_items">
            <van-col span="24">
              <van-row>
                <van-col span="12">
                  <div class="imgbox">
                    <img src="/static/images/member_default1.png" alt />
                  </div>
                  <p>{{items2.name}}</p>
                </van-col>
                <van-col span="12" class="r" style="text-align: right;">
                  <span class="span" style="color:black">{{items2.tel}}</span>
                </van-col>
              </van-row>
            </van-col>
            <van-col span="24" style="padding-top:10px">
              <van-row>
                <van-col span="14" class="tick">
                  <p>{{items.ticket.name}}</p>
                </van-col>
                <van-col span="8" class="r2">
                  <span class="span">￥{{items.ticket.price}} × 1</span>
                </van-col>
              </van-row>
            </van-col>
          </van-row>
            </template>
          </template>
        </div>
      </div>
    </div>
    <!-- 平行会议 -->
<div class="meet order_card"  v-if="order_box.parallel.length >0">
      <div class="div">
        <span class="order_title">平行会议</span>
        <p class="op">平行会议“参会人信息”可在【个人中心-我的会议】中补交</p>
        <div class="order_list">
          <template v-for="(items,index) in order_box.parallel">
             <h5 class="px_title">{{items.conference.name}}</h5>
            <template v-for="(items2,index2) in items.data">
               <van-row class="order_items">
              <van-col span="24">
                <van-row>
                  <van-col span="14" class="tick">
                    <p>{{items2.ticket.name}}</p>
                  </van-col>
                  <van-col span="8" class="r2">
                    <span class="span">￥{{items2.ticket.price}} ×{{items2.ticket.quantity}}</span>
                  </van-col>
                </van-row>
              </van-col>
            </van-row>
           </template>
          </template>
        </div>

      </div>
    </div>
    <!-- 住宿费用 -->
    <div class="hotels order_card" v-if="order_box.hotel.length >0">
      <div class="div">
        <span class="order_title">住宿费用</span>
        <div class="hotel_list">
          <template v-for="(items,index) in order_box.hotel">
            <template v-for="(items2,index2) in items.member">
              <div class="hotel_item">
                <van-row class="h_namebox">
                  <van-col span="16">
                    <p class="h_name">
                      <span class="icon_y"></span>{{items.hotel.h_name}} - {{items.hotel.hotel_type}}
                    </p>
                  </van-col>
                  <van-col span="8" class="r2">
                    <span class="span" v-if="items.hotel.price > 0">￥{{items.hotel.price}}  x {{moment(items2.end_time * 1000).diff(moment(items2.start_time * 1000), 'day')}}天</span>
                    <span class="span" v-else>预订</span>
                  </van-col>
                </van-row>
                <p class="h_time">{{items2.start_time,'Y-M-D'|formatDates}}入住，{{items2.end_time,'Y-M-D'|formatDates}}离店，共{{moment(items2.end_time * 1000).diff(moment(items2.start_time * 1000), 'day')}}晚</p>
                <p class="h_time" v-if="items.hotel.price == 0">{{items.hotel.explain}}</p>
                <div class="list">
                  <van-row>
                    <van-col span="24">入住人信息: {{items2.name.name1 == '' ? '未填写':items2.name.name1}}</van-col>
                  </van-row>
                  <van-row>
                    <van-col span="24" v-show="items2.name.name2 != ''">入住人信息: {{items2.name.name2 == '' ? '未填写':items2.name.name2}}</van-col>
                  </van-row>
                </div>
              </div>
             </template>
          </template>
        </div>
      </div>
    </div>
  <!-- 就餐费用 -->
<div class="hotels order_card" v-if="order_box.repast.length >0">
    <div class="div">
      <span class="order_title">就餐费用</span>
      <div class="hotel_list">
        <template v-for="(items,index) in order_box.repast">
        <div class="hotel_item">
          <van-row class="h_namebox">
            <van-col span="16">
              <p class="h_name">
                <span class="icon_y"></span>{{items.data.address}}
               </p>
            </van-col>
            <van-col span="8" class="r2">
              <span class="span">￥{{items.data.price}} × {{items.data.quantity}} </span>
            </van-col>
          </van-row>
          <p class="h_time">就餐时间：{{items.data.start_time,'Y-M-D h:m'|formatDates}} ~ {{items.data.end_time,'Y-M-D h:m'|formatDates}}</p>
        </div>
        </template>
      </div>
    </div>
  </div>
  <!--免费提示-->
<div class="hotels order_card" v-if="order_box.order_info.free_str && order_box.order_info.free_str.length >0">
  <div class="div">
    <span class="order_title">提示</span>
    <div class="hotel_list">
        <div class="hotel_item">
          <p class="h_time">{{order_box.order_info.free_str}}</p>
        </div>
    </div>
  </div>
</div>
    <!-- 费用合计 -->
    <div class="all_pay">
  <!--     <div class="t">
         <van-row>
           <van-col span="12" class="name_left">商品数量</van-col>
           <van-col span="12" class="pay_right">8</van-col>
         </van-row>
         <van-row>
           <van-col span="12" class="name_left">商品总价</van-col>
           <van-col span="12" class="pay_right">￥2423423</van-col>
         </van-row>
         <van-row>
           <van-col span="12" class="name_left">运费</van-col>
           <van-col span="12" class="pay_right">￥32423</van-col>
         </van-row>
         <van-row>
           <van-col span="12" class="name_left">优惠</van-col>
           <van-col span="12" class="pay_right">￥32423</van-col>
         </van-row>
       </div>-->
      <van-row class="all_num">
        <van-col span="24" class="pay_right">
          <span style="font-weight:600">费用合计:</span>&nbsp;
          <span style="color: #f95d34;">￥{{order_amount}}</span>
        </van-col>
        <van-col span="24" style="font-size:12px;text-align:right;color:#ff0000;">
           （ 温馨提示：为给您提供更快捷的发票服务，推荐您使用微信支付）
        </van-col>
      </van-row>
    </div>
    <div class="pay_tishi_box" v-if="order_box.conference">
      {{order_box.conference.conference.pay_desc}}
    </div>
    <!-- 支付方式 -->
   <div class="pay" v-if="order_paylist.length >0">
      <van-row>
        <van-col span="24" class="title">选择支付方式</van-col>
      </van-row>
      <div class="pay_list">
        <van-radio-group v-model="payRadio" >
          <van-cell-group>
            <van-cell v-for="(item, index) in order_paylist" clickable   @click="payRadio = (index+1) " v-if="conference.conference.scene_pay_type == 1">
                    <div class="imgbox">
                      <img :src="paylist[0].imgurl" alt="" v-if="item.app_url.param.pay_type == 'wxh5' || item.app_url.param.pay_type == 'wxpay'">
                      <img :src="paylist[1].imgurl" alt="" v-if="item.app_url.param.pay_type == 'alih5' || item.app_url.param.pay_type == 'alipay'">
                      <img :src="paylist[2].imgurl" alt="" v-if="item.app_url.param.pay_type == 'unih5' || item.app_url.param.pay_type == 'unipay'">
                      <img :src="paylist[0].imgurl" alt="" v-if="item.app_url.param.pay_type == 'wxjsapi'">
                      <img :src="paylist[3].imgurl" alt="" v-if="item.app_url.param.pay_type == 'purse'">
                    </div>
              <template v-if="item.app_url.param.pay_type == 'wxh5' || item.app_url.param.pay_type == 'wxpay'">
                      {{paylist[0].text}}
                    </template>
              <template v-if="item.app_url.param.pay_type == 'alih5'|| item.app_url.param.pay_type == 'alipay'">
                      {{paylist[1].text}}
                    </template>
              <template v-if="item.app_url.param.pay_type == 'unih5' || item.app_url.param.pay_type == 'unipay'">
                      {{paylist[2].text}}
                    </template>
                    <template v-if="item.app_url.param.pay_type == 'wxjsapi'">
                     {{paylist[0].text}}
                    </template>
                    <template v-if="item.app_url.param.pay_type == 'purse'">
                      {{paylist[3].text}}
                    </template>
                    <template #right-icon>
                     <van-radio :name="(index+1)" shape="square" />
                    </template>
            </van-cell>
            <van-cell clickable @click="payRadio = 0" v-if="conference.conference.is_offline == 1">
              <div class="imgbox">
                <img :src="paylist[4].imgurl" alt="">
              </div>
              {{paylist[4].text}}
              <template #right-icon>
                  <van-radio :name="0" shape="square" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-col v-if="iswx" span="24" style="font-size:12px;text-align:center;color:#ff0000;padding:6px 0px;">
          （支付宝支付：由于微信小程序里无法使用支付宝进行支付，如需使用支付宝支付，请用手机或PC端在浏览器打开该链接进行报名。 如您正在使用手机报名，您可在当前页面点击右上角“...”跳转浏览器以完成支付。）
        </van-col>
      </div>
    </div>
    <div class="ok_pay" @click="go_pay()">确定支付</div>
   <!-- 浮动菜单-->
    <template v-if="Object.keys(conference.conference).length != 0">
        <footerFixed :id="conference.conference.id" :jump-page="conference.conference.jump_page"/>
    </template>


    <van-dialog v-model="wx_dialog_show" title="微信扫码支付" show-cancel-button>
      <img :src="wxImgUrl"  class="wx_imgclass"/>
    </van-dialog>
  </div>
</template>

<script>
  import { formatDates ,formatWeekDate } from "../../assets/js/date";
  import footerFixed from  '@/components/common/fixed_setting'
  import moment from 'moment'

  export default {
    components: {
      footerFixed
    },
  data() {
    return {
      moment,
      order_no:'',//订单号
      paylist: [
        {
          text:'微信支付',
          imgurl:require('../../assets/images/weixinzhifu.png')
        },
        {
          text:'支付宝支付',
          imgurl:require('../../assets/images/zhifubao.png')
        },
        {
          text:'银联支付',
          imgurl:require('../../assets/images/yinlian.png')
        },
        {
          text:'余额支付',
          imgurl:require('../../assets/images/purse.png')
        },
        {
          text:'线下支付',
          imgurl:require('../../assets/images/xianxia.png')
        }
      ],
      payRadio:'',
      order_box:{
        hotel:[],
        order_info:{
          free_str:''
        },
        parallel:[],
        repast:[]
      },//订单详情
      conference:{
        conference:{},
        data:[]
      },//主会议
      hy_name:'',
      order_amount:'',
      footerNav: false,
      checked:true,
      order_paylist:[],
      is_free:{
        status:false,
        bookType:'',
        text:''
      },
      redirect_url:'',
      iswx:false,
      wx_dialog_show:false,//二维码支付弹框
      wxImgUrl:'',//微信支付二维码
    };
  },
  /* 时间过滤 */
  filters: {
    formatDates,//调用方法formatTime(1575346406, 'Y年M月D日 h:m:s')
    formatWeekDate //
  },
  created: function(){
    var _this = this;
    _this.order_no = _this.$route.params.order_no;
    _this.loadEnroll();
    sessionStorage.removeItem('backEnroll'+_this.conference.conference.id);

    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
     _this.iswx = true;
    }
  },
  methods: {
    //打开底部链接
    openFooterNav(val) {
      //   this.$toast(val);
      if (this.footerNav) {
        this.footerNav = false;
      } else {
        this.footerNav = true;
      }
    },
    IsMobile() {

    var sUserAgent = navigator.userAgent.toLowerCase();

    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";

    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";

    var bIsMidp = sUserAgent.match(/midp/i) == "midp";

    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";

    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";

    var bIsAndroid = sUserAgent.match(/android/i) == "android";

    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";

    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";

    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {

       //移动站
        return 'wap';
      } else {

        //PC站
        return 'web';
      }
    },
    loadEnroll(){
      var _this = this;
      let url = "/ac1/conference/orderDetail";//订单详情
      let url2 = "/pay/paymode";//去支付接口
      var is_type = _this.IsMobile();
      if (/(micromessenger)/i.test(navigator.userAgent) && _this.IsMobile() == 'wap') {
        is_type = 'weixin'
      }
      let params = {
        order_no:_this.order_no,
        pay_type:is_type,
        callbacktype:'json'
      };
      _this.$get(url, params).then(res => {
        if (res.code == "1") {
          _this.order_box = res.posts;
          if( _this.order_box.conference.length != 0){
            _this.conference = _this.order_box.conference;
            var con = _this.order_box.conference.data.length;
            _this.redirect_url = res.posts.redirect_url;
            if(con >0){
              _this.hy_name = _this.order_box.conference.conference.name;
            }
            var getShare =JSON.parse(sessionStorage.getItem('hy_shareData'+_this.order_box.conference.conference.id));
            if(getShare != null){
              _this.$WXConfig.wxShowMenu({ifshare:true,that:_this,data:getShare});
            }else{
              _this.$WXConfig.wxShowMenu({ifshare:true,that:_this,data:''});
            }

          }
          _this.order_amount = _this.order_box.order_info.amount;
        }else{
          _this.$toast(res.msg);
        }
      },function(res){
        console.log(res.msg);
      });
      _this.$post(url2, params).then(res => {
        if (res.code == "1") {
          if(res.posts.bookType == 1){
            _this.order_paylist = res.posts.pay;
          }else if(res.posts.bookType == 2517 || res.posts.bookType == 2539){
            _this.$router.go(-1);
            _this.$toast(res.msg);
          }else if(res.posts.bookType == 2000 || res.posts.bookType == 2001){
            _this.is_free = {
              status:true,
              bookType:res.posts.bookType,
              text:res.msg
            }
          }
        }else{
          _this.$toast(res.msg);
        }
      },function(res){
        console.log(res.msg);
      });
    },
    //確定支付
    go_pay(){
      var _this = this;
      if(_this.payRadio === 0){
        let urlx = '/ac1/conference/modifyOffline';
        let paramsx= {
          order_no:_this.order_no
        }
        _this.$post(urlx, paramsx).then(res => {
          if (res.code == "1") {
            /*_this.$toast('预报名成功！本次报名为预报名，请您及时联系部门负责人，并汇款到指定账号，汇款成功后与您所在部门负责人联系，进行订单核实！');*/
            sessionStorage.setItem('hy_xianxia_'+_this.order_no,'offline');
           _this.$router.push('/huikuan/'+_this.order_no);
          }else{
            _this.$toast(res.msg);
          }
        },function(res){
          console.log(res.msg);
        });
        return  false;
      }
      if(_this.payRadio === ''){
        //是免费资源的话
        if(_this.is_free.status){
          if(_this.is_free.bookType == 2000){
            _this.$toast(_this.is_free.text);
            setTimeout(function(){
              _this.$router.push('/signsuccess/'+_this.order_no);
            },1000)
          }else{
            _this.$toast(_this.is_free.text);
          }
        }else{
          _this.$toast('请选择支付方式');
          return false;
        }
      }else{
          //购买选择支付方式走订单
          var paybox = _this.order_paylist[_this.payRadio-1];
          let url = "/"+paybox.app_url.rule;//购买地址
        if(_this.IsMobile() == 'web' && (paybox.app_url.param.pay_type == 'alipay' || paybox.app_url.param.pay_type == 'unipay')){
          window.location.href = url + '?order_no=' + _this.order_no + '&pay_type=' + paybox.app_url.param.pay_type +'&backUrl=https://'+window.location.host+'/ac1/conference/wxJump?order_no='+_this.order_no;
          return false;
        }
          let params = {
            order_no:_this.order_no,
            pay_type:paybox.app_url.param.pay_type,
            callbacktype:'json',
            backUrl: 'https://'+window.location.host+'/ac1/conference/wxJump?order_no='+_this.order_no
          };
          _this.$post(url, params).then(res => {
            if(_this.IsMobile() == 'wap'){
              if(paybox.app_url.param.pay_type == 'alih5' || paybox.app_url.param.pay_type == 'unih5'){
                document.querySelector('body').innerHTML = res;
                const div = document.createElement('div') // 创建div
                div.innerHTML = res // 将返回的form 放入div
                document.body.appendChild(div)
                document.forms[0].submit()
              }else if(paybox.app_url.param.pay_type == 'wxh5'){
                window.location.href = res.posts.html;
              }else if(paybox.app_url.param.pay_type == 'wxjsapi'){
                _this.callpay(res.posts.res);
              }else if(res.code  == 1 && res.posts.type == 'purse'){
                this.$router.push('/signsuccess/'+_this.order_no);
              }
            }else{
              _this.wxImgUrl = res.posts.qrcode;
              _this.wx_dialog_show = true;
              _this.getOrderStatus();
            }
          },function(res){
            console.log(res.msg);
          });
      }
    },
    jsApiCall(data)
    {
      var _this =this;
        WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        data,
        function (res) {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            parent.window.location.href = 'https://'+window.location.host+'/ac1/conference/wxJump?order_no='+_this.order_no
          } else if (
            res.err_msg === 'get_brand_wcpay_request:cancel') {
          } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
            //            }else if(res.errMsg === 'chooseWXPay:fail, the permission value is offline verifying'){
            //                console.log(res.errMsg);
        }
      }
      );
  },
    callpay(data) {
      var _this =this;
    if (typeof WeixinJSBridge == "undefined") {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', _this.jsApiCall, false);
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady',  _this.jsApiCall);
        document.attachEvent('onWeixinJSBridgeReady',  _this.jsApiCall);
      }
    } else {
      _this.jsApiCall(data);
    }
  },
    getOrderStatus(){
      var _this = this;
      _this.$post('/pay/verification', {order_no:_this.order_no}).then(res => {
        if (res.posts.status == 'finished') {
          this.$router.push('/signsuccess/'+_this.order_no);
        } else {
          setTimeout(function(){
            _this.getOrderStatus();
          },2000)
        }
      },function(res){
        console.log(res.msg);
      });
    }
  }
};
</script>

<style lang="less" scoped>
  //确认订单
  .confirm_order {
    width: 100%;
    min-height: 100vh;
    background: #f7f7f7;
    font-size: 28px;
    .order_card {
      width: 100%;
      background-color: white;
      .div {
        .order_title{
          margin: 0px 30px;
          font-size:30px;
          font-weight: 600;
          padding-left: 10px;
          line-height: 30px;
          border-left: 6px solid #189bff;
        }
        >p {
          color: black;
          font-size: 30px;
          line-height: 40px;
          font-weight: 400;
          padding: 40px 30px;
          border-bottom: 2px solid #ebebeb;
        }
        >span {
          display: inline-block;
        }
        .order_list{
          width:100%;
          padding:0px 30px;
          border-bottom: 2px solid #ebebeb;
          .px_title{
            line-height: 35px;
            font-size: 28px;
            color: #333;
            padding-top: 20px;
          }
          >.van-row {
            font-size: 28px;
            line-height: 80px;
            overflow: hidden;
            text-align: left;
            padding: 20px 0px;
            border-bottom: 2px dashed #ebebeb;
            .van-col {
              overflow: hidden; /*超出部分隐藏*/
              white-space: nowrap; /*不换行*/
              text-overflow: ellipsis; /*超出部分文字以...显示*/
              .imgbox{
                display: block;
                width: 70px;
                height: 70px;
                position: relative;
                vertical-align: middle;
                float: left;
                margin-right: 20px;
                overflow: hidden;
                img {
                  width: 100%;
                  height: 100%;
                  display: block;
                  border-radius: 50%;
                }
              }
              >p{
                font-size: 28px;
                color: #333;
                float: left;
                width: 250px;
                line-height: 70px;
                overflow: hidden; /*超出部分隐藏*/
                white-space: nowrap; /*不换行*/
                text-overflow: ellipsis; /*超出部分文字以...显示*/
              }
              .r{
                height: 70px;
                .span {
                  color: #f95d34;
                  font-size: 28px;
                  display: block;
                  line-height: 70px;
                  width: 100%;
                }
              }
              .tick {
                color: #f95d34;
                p {
                  width: 100%;
                  //padding: 0px 10px 0px 20px;
                  //  background-color: #ffe4dd;
                  margin: 0;
                  overflow: hidden; /*超出部分隐藏*/
                  white-space: nowrap; /*不换行*/
                  text-overflow: ellipsis; /*超出部分文字以...显示*/
                  line-height: 55px;
                  font-size: 26px;
                  font-weight: normal;
                  border-radius: 10px;
                  color: #f95d34;
                }
              }
              .r2{
                height: 55px;
                float: right;
                .span{
                  line-height: 55px;
                  font-size: 28px;
                  display: block;
                  width: 100%;
                  text-align: right;
                  color: #f95d34;
                }
              }
            }
            &:last-child{
              border-bottom: none;
            }
          }
          &:last-child{
            border-bottom: none;
          }
        }
      }
    }
    .meet {
      margin-top: 30px;
      background-color: white;
      .div {
        padding-top: 40px;
        .op {
          font-weight: normal !important;
          font-size: 28px;
          padding: 20px 30px;
          overflow: hidden;
          color: #b2b2b2;
        }
      }
    }
    .hotels {
      margin-top: 30px;
      .div{
        width:100%;
        padding-top: 40px;
        .hotel_list{
          width:100%;
          padding:0px  30px;
          .hotel_item{
            width:100%;
            padding:30px  0px;
            border-bottom: 2px solid #ebebeb;
            span {
              display: inline-block;
            }
            .h_namebox{
              .h_name{
                margin-bottom: 10px;
                line-height: 40px;
                overflow: hidden;
                padding-left: 25px;
                position: relative;
                span{
                  position: absolute;
                  top: 12px;
                  left: 0px;
                  width: 14px;
                  height: 14px;
                  float: left;
                  display: block;
                  border-radius: 50%;
                  background: #f95d34;
                }
              }
              .r2{
                height: 40px;
                float: right;
                .span{
                  line-height: 40px;
                  font-size: 28px;
                  display: block;
                  width: 100%;
                  text-align: right;
                  color: #f95d34;
                }
              }
            }

            .h_time{
              color:#999999;
              margin-bottom: 10px;
              line-height: 40px;
              overflow: hidden;
              padding-left: 25px;
            }
            .list{
              padding: 10px 0px 0px 25px;
              .van-row {
                margin-bottom: 10px;
              }
            }
            &:last-child{
              border-bottom: none;
            }
          }
        }
      }
    }
    .all_pay {
      width: 100%;
      background-color: white;
      margin-top: 30px;
      .t{
        padding: 20px 0px;
      }
      .van-row {
        padding: 10px 30px;
        .name_left {
          color: #a8a8a8;
        }
        .pay_right {
          text-align: right;
        }
        &.all_num{
          text-align: right;
          padding: 30px;
          border-top: 2px solid #ebebeb;
          font-size: 30px;
        }
      }
    }
    .pay_tishi_box{
      width: 100%;
      padding: 0px 30px;
      font-size: .32rem;
      text-align: left;
      color: rgb(255, 0, 0);
      margin-top: 20px;
      line-height: 0.48rem;
    }
    .pay {
      width: 100%;
      background-color: white;
      margin-top: 30px;
      .van-row {
        padding: 30px 30px;
        border-bottom: 2px solid #ebebeb;
        .van-col{
          font-size: 28px;
          line-height: 40px;
        }
        .title{
          font-size:30px;
          font-weight: 600;
        }
      }
      .pay_list {
        overflow: hidden;
        .van-radio-group{
          display: block;
          .van-icon{
            width: 0.4rem;
            height: 0.4rem;
            font-size: 0.32rem;
            float: right;
          }
          .van-radio__icon--checked .van-icon{
            background-color: #FFF;
            color: #f95d34;
            border: 0.026667rem solid #f95d34;
          }
          .imgbox{
            width: 50px;
            height: 50px;
            display: inline-block;
            img {
              width: 47px;
              vertical-align: middle;
              margin-right: 20px;
            }
          }
        }
      }
    }
    .ok_pay {
      width: 100%;
      height: 100px;
      margin-top: 80px;
      background-color: #ff734a;
      text-align: center;
      line-height: 100px;
      font-size: 30px;
      color: white;
    }

  }
  .wx_imgclass{
    margin: 0 auto;
    display: block;
  }
</style>
